import * as React from "react";

function ChevronDown(props) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.333 9.323L12.8 5l.867.838L8.333 11 3 5.838 3.866 5l4.467 4.323z"
      />
    </svg>
  );
}

export default ChevronDown;
